import 'core-js';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { initialiseBctApiPermissionReducers } from '@ngt/online-patient-management-bctapi-permissions';
import { RequestState } from '@ngt/request-utilities';
import { SnackbarProvider } from 'notistack';

import { onlinePatientManagement, OnlinePatientManagement } from '@ngt/online-patient-management-ui';

import App from './App';
import * as serviceWorker from './serviceWorker';
import * as Dtos from './api/Neon.Dtos';
import client from './api/client';
import { LOGIN_LINK } from './constants/authentication';
import reducerRegistry from './store/reducerRegistry';
import { Settings as LuxonSettings } from 'luxon';

declare let global: any;

if (typeof global === 'undefined') {
    (window as any).global = window;
}

const user = global.AUTH as Dtos.AuthenticateResponse;
const typeMapping = global.TYPE_MAPPING as Dtos.GetOpmsTypeMappingResponse as any;

if (!user) {
    window.location.href = LOGIN_LINK;
}

//set default timezone to australia/sydney so dates at midnight appear as the correct day for users in other timezones in the world
LuxonSettings.defaultZoneName = 'Australia/Sydney';

onlinePatientManagement.configure({
    typeMapping,
    theme: {
        primaryColour: '#562c85',
        secondaryColour: '#e8078c'
    },
    store: {
        preloadState: {
            authenticatedUser: {
                user,
                loadState: {
                    state: RequestState.Success
                }
            }
        }
    },
    dtos: Dtos,
    reducerRegistry
});

initialiseBctApiPermissionReducers(onlinePatientManagement.reducerRegistry, Dtos, client);

export const store = onlinePatientManagement.store;
export const reduxPromiseListener = onlinePatientManagement.reduxPromiseListener;

ReactDOM.render(
    <OnlinePatientManagement>
        <SnackbarProvider
            maxSnack={1}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
        >
            <App hasUser={!!user} />
        </SnackbarProvider>
    </OnlinePatientManagement>,
    document.getElementById('root') as HTMLElement
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();